import {
  collection,
  doc,
} from 'firebase/firestore';

import {
  db,
} from '@/services/firebase.js';

import {
  timeline_child_path,
} from './utils.js';

import {
  converters,
} from '../converters/index.js';

export const timeline_row_refs = {
  document: ({
    is_published,
    workspace_id,
    project_id,
    timeline_id,
    timeline_row_id,
  }) => {
    const path = timeline_child_path({
      is_published,
      workspace_id,
      project_id,
      timeline_id,
      collection_name: 'timeline_rows',
      document_id: timeline_row_id,
    });
    return doc(db, path).withConverter(converters.timeline_rows);
  },
  collection: ({
    is_published,
    workspace_id,
    project_id,
    timeline_id,
  }) => {
    const path = timeline_child_path({
      is_published,
      workspace_id,
      project_id,
      timeline_id,
      collection_name: 'timeline_rows',
    });
    return collection(db, path).withConverter(converters.timeline_rows);
  },
};
